import { NAV_FEATURES } from '../features.registry';

export const PROVIDER_FEATURES = [

    NAV_FEATURES.DASHBOARD,
    NAV_FEATURES.YOUR_CUSTOMERS,
    NAV_FEATURES.FARM_USERS,
    NAV_FEATURES.POND_METRICS,
    NAV_FEATURES.FEED_METRICS,
    NAV_FEATURES.DENSITY_METRICS,
    NAV_FEATURES.HARVEST_METRICS,
    NAV_FEATURES.WATER_QUALITY_METRICS,
    NAV_FEATURES.SAMPLING_METRICS,
    NAV_FEATURES.WATER_QUALITY_READINGS_METRICS,
    NAV_FEATURES.YOUR_BUSINESS,
    NAV_FEATURES.YOUR_FIELD_FORCE,
    NAV_FEATURES.BARCODES,
    NAV_FEATURES.PRODUCTS,
    NAV_FEATURES.ORDERS,
    NAV_FEATURES.CULTURE_SUMMARY,
    NAV_FEATURES.POND_SUMMARY,
    NAV_FEATURES.DAY_SUMMARY,
    NAV_FEATURES.TRACEABILITY_SUMMARY,
    NAV_FEATURES.ACTIVITY_TRACKER_LEADS,
    NAV_FEATURES.VISITS
] as const;

export const PROVIDER_MANAGER_REMOVED_FEATURES = [
    NAV_FEATURES.YOUR_BUSINESS,
    NAV_FEATURES.BARCODES,
    NAV_FEATURES.PRODUCTS
] as string[];

export const getProviderFeatures = () => Array.from(PROVIDER_FEATURES);

export const getProviderManagerFeatures = () => Array.from(PROVIDER_FEATURES).filter(
    (f) => !PROVIDER_MANAGER_REMOVED_FEATURES.includes(f)
)